import { render, staticRenderFns } from "./QuotaUsage.vue?vue&type=template&id=dbc7106e"
import script from "./QuotaUsage.vue?vue&type=script&lang=js"
export * from "./QuotaUsage.vue?vue&type=script&lang=js"
import style0 from "./QuotaUsage.vue?vue&type=style&index=0&id=dbc7106e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports